import { defaultTemplate } from 'core/hoc';
import { DatePicker } from 'core/components';
import { BaasicButton } from 'core/components';
import { Loader } from 'core/components';
import React from 'react';

const ChangeWarehouseShipByDateTemplate = ({ changeWarehouseShipByDateViewStore, t }) => {
	const { loading, form, datePickerFormat } = changeWarehouseShipByDateViewStore;
	if (loading) return <Loader />;
	return (
		<form onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<div className="flex--secondary">
					<h3 className="spc--bottom--sml">{t('CHANGEWAREHOUSESHIPBYDATE.TITLE')}</h3>
				</div>
			</div>
			<div className="ReactModal__body">
				<div className="row">
					<div className="col col-sml-12 col-med-12">
						<DatePicker field={form.$('warehouseShipByDate')} format={datePickerFormat} />
					</div>
				</div>
			</div>
			<div className="ReactModal__footer">
				<div className="row">
					<div className="col col-sml-3 col-med-2">
						<BaasicButton type="submit" label={t('SAVE')} className="btn btn--med btn--primary spc--bottom--sml" />
					</div>
				</div>
			</div>
		</form>
	);
};

export default defaultTemplate(ChangeWarehouseShipByDateTemplate);
